<template>
  <component
    :is="component"
    :class="
      'text-' +
      textColor +
      ' bg-' +
      bgColor +
      (divider && component === 'QHeader'
        ? ' d-bottom-border'
        : divider && component === 'QFooter'
        ? ' d-top-border'
        : '')
    "
    :ref="`component-toolbar-${component}`"
  >
    <q-toolbar :class="component === 'QFooter' ? 'toolbar' : ''">
      <div class="row justify-between items-center content-center full-width">
        <slot />
      </div>
    </q-toolbar>
  </component>
</template>
<script>
import mixin from "./d-card-mixins";
import { QFooter, QHeader, debounce } from "quasar";
import DCardBusinessBanner from "./DCardBusinessBanner.vue";

export default {
  name: "DCardToolbar",
  mixins: [mixin],
  components: { QHeader, QFooter, DCardBusinessBanner },
  data() {
    return {
      resizeObserver: null,
    };
  },
  props: {
    component: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "dark",
    },
    textColor: {
      type: String,
      default: "white",
    },
    divider: {
      type: Boolean,
      default: false,
    },
    humanFilters: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.onResize = debounce(this.onResize, 500);
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(() => {
      this.onResize(
        this.$refs[`component-toolbar-${this.component}`]?.$el.clientHeight
      );
    });

    this.resizeObserver.observe(
      this.$refs[`component-toolbar-${this.component}`]?.$el
    );
  },
  methods: {
    onResize(size) {
      this.$emit("resize", size + 1);
    },
  },
  beforeDestroy() {
    this.resizeObserver.unobserve(
      this.$refs[`component-toolbar-${this.component}`]?.$el
    );
  },
};
</script>

<style lang="scss" scoped>
@import url("./d-card.scss");

.q-header .q-toolbar {
  min-height: 48px;
  padding-right: 16px;
  padding-left: 16px;
}

.toolbar {
  min-height: 40px;
}
</style>
